import { useFieldLocalYupValidationBase, } from './useField';
export function useTextField(props) {
    const [baseProps, saveValue, setValidationValue] = useFieldLocalYupValidationBase({
        ...props,
        initialState: '',
    });
    return {
        ...baseProps,
        onBlur: (e) => {
            const value = e.target.value;
            saveValue((props.trim ? value.trim() : value));
        },
        onChange: (e) => {
            const value = e.target.value;
            setValidationValue((props.trim ? value.trim() : value));
        },
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationTextField = useTextField;
